import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import ScoreCompanyService from '../../../../../../core/service'

//getScorePerformance
export const getScorePerformance = createAsyncThunk(
  'companyAnalysis/companyScore/performance/getScorePerformance',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getScorePerformance(params)
      if (response.success) return response.data
      return null
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
